const request = {
    invalid_input: 'Неверный ввод. {{details}}',
    general: 'Произошла ошибка запроса.',
    range_not_satisfiable: 'Диапазон не удовлетворен.',
    feature_not_supported: 'Эта функция не поддерживается в текущей среде.',
};
export default Object.freeze(request);
